import { render } from "./InputKokykIdWithButton.vue?vue&type=template&id=6553ac3d"
import script from "./InputKokykIdWithButton.vue?vue&type=script&lang=js"
export * from "./InputKokykIdWithButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__